/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles, AppBar, Toolbar, Typography, Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  appBar: ({ drawerWidth }) => ({
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  }),
  toolbar: {
    marginLeft: 'auto',
    padding: theme.spacing(8, 8, 5),
  },
}));

export default function Header({ drawerWidth }) {
  const classes = useStyles({ drawerWidth });
  return (
    <AppBar position="fixed" color="transparent" className={classes.appBar} elevation={0}>
      {/* <Toolbar /> */}
      <Toolbar className={classes.toolbar}>
        <Typography variant="h5" noWrap>
          Having troubles? <Link href="#">Get help</Link>
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
